export default __webpack_public_path__ + "static/page-preview-b720c8be4fd677cd87bd00508162e1fe.jpg";